export default function ProcessingModal({
  stage,
  name = "Consultation",
  createdAt,
}) {
  const label =
    stage === "uploading"
      ? "Uploading…"
      : stage === "transcribing"
      ? "Transcribing…"
      : stage === "filling"
      ? "Filling template…"
      : "Processing…";

  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <div className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
        {/* spinner */}
        <svg className="h-5 w-5 animate-spin text-gray-700" viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4A4 4 0 004 12z"
          />
        </svg>

        <div className="min-w-0">
          <div className="text-sm font-medium text-gray-900">{label}</div>
          <div className="text-xs text-gray-500 truncate">
            {name}
            {createdAt ? ` • ${new Date(createdAt).toLocaleString()}` : ""}
          </div>
        </div>
      </div>
    </div>
  );
}
